import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { config } from '@app/core/app-config';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface HostInviteUser {
  name: string;
  email: string;
}

export interface PropertySelectionState {
  id: string | number;
  selected: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class InviteHostsService {
  constructor(private readonly http: HttpClient) {}

  sendInvites(users: HostInviteUser[], platform?: string, platformId?: string, scopeType?: 'pms' | 'ops'): Observable<any> {
    users = users.filter((user) => user.name && user.email);

    const payload = {
      users,
    };

    // Used when we want to take a specific channel details into consideration
    if (platform && platformId) {
      payload['platform'] = platform;
      payload['platform_id'] = platformId;
    }

    if (scopeType) {
      payload['airbnb_scope_type'] = scopeType;
    }

    return this.http.post(`${config.API_URL}/settings/channels/invite`, payload);
  }

  fetchInviteDetails(token: string): Observable<any> {
    return this.http.get(`${config.API_URL}/hosts/invitation/${token}`);
  }

  fetchListings(platform: string, channelId: string, invitationUuid?: string) {
    let url = `${config.API_URL}/hosts/invitation/listings/${platform}/${channelId}`;

    if (invitationUuid) {
      url += `/${invitationUuid}`;
    }

    return this.http.get(url).pipe(
      map((res: any) => res.data),
      map((res) => {
        res.forEach((element) => {
          // If the listing has been previously muted, we do not pre-select it
          element.allowAccess = ! element.muted;
        });
        return res;
      })
    );
  }


  /**
   * Synchronizes properties' muted/unmuted states based on whether those were selected during invitation.
   */
  syncProperties(selectionStates: PropertySelectionState[], invitationUuid: string): Observable<any> {
    return this.http.post(`${config.API_URL}/hosts/invitation/sync-properties/${invitationUuid}`, {
      properties: selectionStates,
    });
  }
}
